var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExchangeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_217_7615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9999 26.2197C38.5899 26.2197 38.2499 26.5597 38.2499 26.9697C38.2499 29.9297 36.1899 32.4097 33.4199 33.0597L33.6899 32.6097C33.8999 32.2497 33.7899 31.7897 33.4299 31.5797C33.0799 31.3697 32.6099 31.4797 32.3999 31.8397L31.3499 33.5897C31.2099 33.8197 31.2099 34.1097 31.3399 34.3397C31.4699 34.5797 31.7199 34.7197 31.9899 34.7197C36.2599 34.7197 39.7399 31.2397 39.7399 26.9697C39.7499 26.5597 39.4099 26.2197 38.9999 26.2197Z",
    fill: "#3E474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 11.2197C19.73 11.2197 16.25 14.6997 16.25 18.9697C16.25 19.3797 16.59 19.7197 17 19.7197C17.41 19.7197 17.75 19.3797 17.75 18.9697C17.75 16.0097 19.81 13.5297 22.58 12.8797L22.31 13.3297C22.1 13.6897 22.21 14.1497 22.57 14.3597C22.92 14.5697 23.39 14.4597 23.6 14.0997L24.65 12.3497C24.78 12.1197 24.79 11.8397 24.65 11.5997C24.52 11.3697 24.27 11.2197 24 11.2197Z",
    fill: "#5ED5A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5002 19.67C37.5002 22.75 35.2602 25.29 32.3302 25.76C32.3302 25.75 32.3302 25.75 32.3302 25.74C32.0402 22.01 29.0202 18.97 25.2402 18.67C25.7102 15.74 28.2502 13.5 31.3302 13.5C34.7402 13.5 37.5002 16.26 37.5002 19.67Z",
    fill: "#3E474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8101 25.2003C25.8101 25.0503 25.6401 24.8203 25.4301 24.8203H23.3701V25.5703H25.4301C25.6401 25.5803 25.8101 25.4103 25.8101 25.2003Z",
    fill: "#5ED5A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8301 27.0801H25.4301H23.3701V27.8301H25.8401C26.1601 27.8301 26.3801 27.6301 26.3801 27.4501C26.3801 27.2701 26.1501 27.0801 25.8301 27.0801Z",
    fill: "#5ED5A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.83 25.8504C30.6 22.8204 28.18 20.4004 25.15 20.1704C24.99 20.1604 24.84 20.1504 24.67 20.1504C21.26 20.1504 18.5 22.9104 18.5 26.3304C18.5 29.7404 21.26 32.5004 24.67 32.5004C28.08 32.5004 30.85 29.7404 30.85 26.3304C30.85 26.1604 30.84 26.0104 30.83 25.8504ZM25.83 29.3304H25.17V29.7104C25.17 30.1204 24.83 30.4604 24.42 30.4604C24.01 30.4604 23.67 30.1204 23.67 29.7104V29.3304H22.62C22.21 29.3304 21.87 28.9904 21.87 28.5804V26.3304V24.0804C21.87 23.6704 22.21 23.3304 22.62 23.3304H23.67V22.9504C23.67 22.5404 24.01 22.2004 24.42 22.2004C24.83 22.2004 25.17 22.5404 25.17 22.9504V23.3304H25.43C26.43 23.3304 27.31 24.2104 27.31 25.2104C27.31 25.5004 27.24 25.7704 27.12 26.0204C27.58 26.3604 27.87 26.8804 27.87 27.4604C27.87 28.4904 26.96 29.3304 25.83 29.3304Z",
    fill: "#5ED5A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_217_7615",
    x: 0.25,
    y: 0.219727,
    width: 55.4902,
    height: 55.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.835294 0 0 0 0 0.658824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_217_7615"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_217_7615",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeIcon);
export default __webpack_public_path__ + "static/media/exchangeIcon.bb807d2143f804c4ce6e745882526d13.svg";
export { ForwardRef as ReactComponent };